import { InputLabel, TextField } from "@mui/material";
import { SelectWrapper } from "components/UiComponents";
import { Controller } from "react-hook-form";

export const NumberField = ({
  name,
  label,
  control,
  rules,
  error,
  step = "any",
}) => (
  <SelectWrapper>
    <InputLabel id={`select-${name}-label`} htmlFor={`input-${name}`}>
      {label}
    </InputLabel>
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <TextField
          {...field}
          sx={{ width: "120px", transform: "translateY(-4px)" }}
          variant="standard"
          id={`input-${name}`}
          type="number"
          error={!!error}
          helperText={error?.message}
          inputProps={{ step }}
        />
      )}
    />
  </SelectWrapper>
);
